import { getEnvApiMode, getEnvApiUrl, getEnvApiUrls, getEnvOAuth2Url, getEnvOAuth2Urls } from './env';

export enum ApiMode {
  Prod = "production",
  Abo = "abo",
  Dro = "dro",
  Dev = "dev",
  Guyane = "guyane"
}

export let API_MODE = getEnvApiMode() ?? ApiMode.Prod; // use .env => REACT_APP_API_MODE=local

const addToPathNameUrl = (url : string, suffixPathName : string) : string => {
    const urlObj = new URL(url);
    if (urlObj.pathname.endsWith('/') && suffixPathName.startsWith('/')) {
        suffixPathName = suffixPathName.replace('/', '');
    }
    urlObj.pathname += suffixPathName;
    return urlObj.href;
};

const getUrl = () => new URL(window.location.href);

// Source: react-boilerplate => https://github.com/react-boilerplate/react-boilerplate  (app/utils/request.js)

/**
 * Build backend url
 *
 * @returns {string} Returns a url as string
 */
const buildBaseUrl = (protocol: string, target: 'api'|'oauth') => {
  const url = getUrl();
  const hostNameSplitted = url.hostname.split('.');
  hostNameSplitted.splice(0, 1);
  const hostNameStr = hostNameSplitted.join('.');
  return `${protocol}//${target}.${hostNameStr}`;
};

/**
 * Get the url from env variables if exists
 *
 * @returns {string} Returns a url as string
 */
const getApiUrlFromEnvironmentVariable = (): string | undefined => {
  const url = getUrl();
  const envApiUrls = getEnvApiUrls();
  let result: string | undefined;
  Object.keys(envApiUrls).forEach((k) => {
    const hostname = k;
    if (hostname && url.hostname.match(hostname)?.length) {
      result = envApiUrls[k];
    }
  });
  return result ?? getEnvApiUrl();
}

/**
 * Get the url from env variables if exists
 *
 * @returns {string} Returns a url as string
 */
const getOAuth2UrlFromEnvironmentVariable = (): string | undefined => {
  const url = getUrl();
  const envApiUrls = getEnvOAuth2Urls();
  let result: string | undefined;
  Object.keys(envApiUrls).forEach((k) => {
    const hostname = k;
    if (hostname && url.hostname.match(hostname)?.length) {
      result = envApiUrls[k];
    }
  });
  return result ?? getEnvOAuth2Url();
}


/**
 * Get the current backend base (root) url
 *
 * @returns {string} Returns a url as string
 */
const getBaseUrl = (target: 'api'|'oauth') => {
  const url = getUrl();
  return buildBaseUrl(url.protocol, target);
};

export const getApiBaseUrl = () => {
  if (API_MODE === ApiMode.Abo) return 'https://abo.dev.kalyzee.com/606ee9c4bf11b4001c9ac54b';
  if (API_MODE === ApiMode.Dro) return 'https://dro-1.dev.kalyzee.com/606ee9c4bf11b4001c9ac54b/';
  if (API_MODE === ApiMode.Dev) return "https://api.kalyzee.dev.kast.app";
  if (API_MODE === ApiMode.Guyane) return "https://api.guyane.kast.app";

  const envApiUrl = getApiUrlFromEnvironmentVariable();
  if (envApiUrl) return envApiUrl;
  return getBaseUrl('api');
}

export const getOAuthBaseUrl = () => {
  if (API_MODE === ApiMode.Abo) return 'https://abo-2.dev.kalyzee.com';
  if (API_MODE === ApiMode.Dev) return "https://oauth.kalyzee.dev.kast.app";
  if (API_MODE === ApiMode.Guyane) return "https://oauth.guyane.kast.app";
  const envApiUrl = getOAuth2UrlFromEnvironmentVariable();
  if (envApiUrl) return envApiUrl;
  return getBaseUrl('oauth');
}

export const getSocketTokenGenerateUrl = () => `${getApiBaseUrl()}/socket/token`;

const getSocketBaseUrl = () => {
  const url = getUrl();
  if (API_MODE === ApiMode.Abo) return 'wss://abo.dev.kalyzee.com/?organization=606ee9c4bf11b4001c9ac54b';
  if (API_MODE === ApiMode.Dro) return 'wss://dro-1.dev.kalyzee.com/?organization=606ee9c4bf11b4001c9ac54b';
  if (API_MODE === ApiMode.Dev) return "wss://api.kalyzee.dev.kast.app";
  if (API_MODE === ApiMode.Guyane) return "wss://api.guyane.kast.app";

  // Keep same security level : http -> ws & https -> wss
  const envApiUrl = getApiUrlFromEnvironmentVariable();
  if (envApiUrl) {
    const urlObj = new URL(envApiUrl);
    // Keep same security level : http -> ws & https -> wss
    urlObj.protocol = urlObj.protocol.replace("http", "ws");
    return urlObj.href;
  }
  return `${buildBaseUrl(url.protocol.replace('http', 'ws'), 'api')}`;
};

export const getUserSocketUrl = () => addToPathNameUrl(getSocketBaseUrl(), '/user');
  
